export enum ESplashScreenMod {
    blue = 'blue',
    red = 'red',
    faces = 'faces',
}

export interface ISplashScreenContent {
    id: string;
    img: string;
    title: string;
    description: string;
    buttonText: string;
    footerText?: string;
    onClick: () => void;
    mod?: ESplashScreenMod;
}

export type UseContentHook = (props: { productId?: string; onClose?: () => void }) => ISplashScreenContent;

export interface ISplashScreenProps {
    contentHook: UseContentHook;
    productId?: string;
    onClose: () => void;
}
